export default __webpack_public_path__ + "static/media/goal-gamification.15f1ad5f.svg";